const Lemo_Overlay =
    {
        /**
         * Zobrazeni overlay
         */
        show: function () {
            $('#overlay').addClass('active');
            $('body').addClass('overlay-active');

            $(document).on('keydown', function(e){
                e.preventDefault();
            });
        },

        /**
         * Skryti overlay
         */
        hide: function () {
            $('#overlay').removeClass('active');
            $('body').removeClass('overlay-active');

            $(document).off('keydown');
        }
    }

window.Lemo_Overlay || (window.Lemo_Overlay = Lemo_Overlay);
